<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="Image" height="233" src="images/14.jpg" width="350"/></p>
<p class="noindent">Whether it’s a dorm room, apartment, or house, getting your own place goes beyond having a place to sleep—it’s establishing your own home.</p>
<p class="indent">Before getting a place, consider what you want to use your home for. Do you just need space for a bed, or do you need enough room to entertain family and friends?</p>
<p class="indent">Think about what you want your first home to be. Safe? Friendly? Clean? Convenient? Comfortable? Charming? Exciting? Affordable? Spacious? Practical? Extravagant?</p>
<p class="indent">Consider your housing priorities, then use this section to help you find the right place for you.</p>
<p><a id="page_30"></a></p><a id="page_30">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part03.vue?51d809bc